import {
  Alert,
  Avatar,
  Col,
  Layout,
  Menu,
  Popconfirm,
  Rate,
  Row,
  Spin,
} from "antd";
import React, { ReactElement, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  adminServices,
  getServicePaths,
  isAllowedService,
} from "../../../utils/services";
import { LOGIN_SUCCESS, SIDEBAR_COLLAPSE } from "../../../redux/auth/authType";
import { getImgUrl } from "../../../utils";
import LogoImg from "../../../images/logo.png";
import IconImg from "../../../images/favicon.svg";
import noImage from "../../../images/noImage.png";
import {
  AppstoreOutlined,
  IdcardOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  SyncOutlined,
} from "@ant-design/icons";
const { Sider } = Layout;
const { SubMenu } = Menu;
const MainSidebar = (): ReactElement => {
  const { sidebarCollapse, type, shopInfo, merchantInfo } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pathname = window.location.pathname;
  const [loading, setLoading] = React.useState<boolean>(false);
  const [visiblePopconfirm, setVisiblePopconfirm] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const setCollapsed = (value: boolean) => {
    dispatch({
      type: SIDEBAR_COLLAPSE,
      payload: {
        sidebarCollapse: value,
      },
    });
  };

  const showPopconfirm = (mobileNumber: any) => {
    setVisiblePopconfirm(mobileNumber);
  };

  const handleCancel = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setVisiblePopconfirm(undefined);
  };

  const onSetDefault = async (shopId: any) => {
    if (shopId) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          // userType: res?.usertype || "MERCHANT",
          shopInfo: null,
          //shopId: data?.data?.shop?.id,
          iat: new Date(),
          //type: data?.data?.shop?.type || "JC_COMMERCE",
        },
      });
      navigate("/");
    }
  };

  return (
    <>
      <Sider
        width={300}
        collapsible
        collapsed={sidebarCollapse}
        onCollapse={(value) => {
          setCollapsed(value);
        }}
      >
        <div className="logo sticky top-0 z-10">
          <Link to="/">
            <img
              src={sidebarCollapse ? IconImg : LogoImg}
              alt="jachai parcel"
              className="logoImg"
            />
          </Link>
        </div>

        {!sidebarCollapse && (
          <div className="bg-transparent text-white shadow-gray-200 border-b mb-4">
            <div className="">
              <div className="max-h-40 h-40 overflow-hidden">
              {shopInfo?.id == null || shopInfo?.id == '' ? (
                <>
                <img
                  src={
                    merchantInfo?.storeDetails?.storeBanner ||
                    merchantInfo?.merchantPersonalDetail?.profilePicture ||
                    noImage
                  }
                  alt=""
                  className="object-cover min-h-full w-full object-center"
                />
                </>
              ): (
                <>
                <img
                  src={shopInfo?.banner ||
                    noImage
                  }
                  alt=""
                  className="object-cover min-h-full w-full object-center"
                />
                </>
              )}
                
              </div>

              <div className="px-4 pb-2">
                <div className="-mt-8 xl:-mt-8">
                {shopInfo?.id == null || shopInfo?.id == '' ? (
                  <>
                  <Avatar
                    size={70}
                    shape="circle"
                    src={getImgUrl(
                      merchantInfo?.merchantPersonalDetail?.profilePicture ||
                        noImage
                    )}
                    className="mb-5 w-20 h-20 shadow-lg border-2 border-white bg-gray-50"
                  />
                  </>
                 ) : (
                  <>
                  <Avatar
                    size={70}
                    shape="circle"
                    src={getImgUrl(
                        merchantInfo?.storeDetails?.storeLogo ||
                        shopInfo?.logo ||
                        noImage
                    )}
                    className="mb-5 w-20 h-20 shadow-lg border-2 border-white bg-gray-50"
                  />
                  </>
                 ) }
                  
                </div>
                <div>
                  <h2 className="text-lg text-white font-bold">
                    {shopInfo?.name ||
                      merchantInfo?.merchantPersonalDetail?.name ||
                      merchantInfo?.storeDetails?.storeName?.toUpperCase() ||
                      merchantInfo?.fullName?.toUpperCase()}
                  </h2>

                  <Rate
                    value={shopInfo?.rating || merchantInfo?.rating || 1}
                    disabled
                  />
                  <span className="bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-1 py-0.5 rounded-full dark:bg-blue-200 dark:text-blue-800 ml-2">
                    {shopInfo?.numberOfRating ||
                      merchantInfo?.numberOfRating ||
                      0}
                  </span>
                </div>
                <div className="mb-2 text-sm font-medium bg-gray-300 text-slate-800 rounded-md px-2 py-0.5 mt-2 h-10">
                  <div className="w-9/12 float-left h-full text-start mt-2">
                    {shopInfo?.mobileNumber?.replace("+88", "") ||
                      merchantInfo?.mobileNumber?.replace("+88", "")}
                  </div>
                  <div className="w-3/12 float-left h-full text-right mt-2">
                    {merchantInfo?.isMobileVerified === true ? (
                      <p className="text-green-700 font-bold size-12">
                        Verified
                      </p>
                    ) : (
                      <p className=" text-red-700 font-bold size-12">
                        Unverified
                      </p>
                    )}
                  </div>
                </div>
                {shopInfo?.id == null && (
                  <>
                    <div className="mb-2 text-sm font-medium bg-gray-300 text-slate-800 rounded-md px-2 py-5 mt-2">
                      <Row>
                        <Col span={16}>
                          <h2 className="text-lg font-bold">
                            Jachai.com Membership
                          </h2>
                          <p className="text-slate-400 text-xs">
                            Explore US Tk 10 of wih a new seller and more
                            benefits
                          </p>
                        </Col>
                        <Col span={8}>
                          <div
                            className={
                              "hover:from-pink-500 hover:to-yellow-500 text-white font-bold py-1 mt-6 px-4 rounded-full shadow-md bg-gradient-to-r from-indigo-500 via-pink-500 to-red-500"
                            }
                          >
                            <Link to="/membership-level">Upgrade</Link>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        <Menu
          defaultOpenKeys={[getServicePaths(pathname)]}
          mode="inline"
          theme="dark"
        >
          {shopInfo?.id == null || shopInfo?.id == '' ? (
            <>
              {adminServices?.map((service, i) => {
                if (service?.sub && service?.sub?.length) {
                  if (
                    service?.sub?.filter((item) => {
                      const excludeIcon = item;
                      return (
                        excludeIcon?.icon &&
                        isAllowedService(`${service.name} ${item.name}`)
                      );
                    })?.length === 1 &&
                    service?.sub?.find((item) => {
                      return item.isParent;
                    })
                  ) {
                    const actualPath = `${service?.path}${service?.sub?.[0]?.path}`;

                    return (
                      <Menu.Item
                        key={service?.path}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                        className={
                          pathname === actualPath && service?.path
                            ? "active"
                            : ""
                        }
                      >
                        <Link to={actualPath}>
                          {type == "JC_FOOD"
                            ? service?.name
                                ?.replace("Shops", "Restaurants")
                                ?.replace("Product", "Menu")
                            : service?.name}
                        </Link>
                      </Menu.Item>
                    );
                  } else {
                    return (
                      service?.sub?.find((item) =>
                        isAllowedService(`${service.name} ${item.name}`)
                      ) && (
                        <SubMenu
                          key={service?.path}
                          icon={<FontAwesomeIcon icon={service?.icon} />}
                          title={service?.name?.replace("Shops", "Restaurants")}
                        >
                          {service?.sub?.map((sub) => {
                            const actualPath = `${service?.path}${sub?.path}`;
                            const excludeIcon = sub;
                            return (
                              !actualPath.includes(":") &&
                              excludeIcon?.icon &&
                              isAllowedService(
                                `${service.name} ${sub.name}`
                              ) && (
                                <Menu.Item
                                  key={actualPath}
                                  icon={<FontAwesomeIcon icon={sub?.icon} />}
                                  className={
                                    pathname === actualPath ? "active" : ""
                                  }
                                >
                                  <Link to={actualPath}>{sub?.name}</Link>
                                </Menu.Item>
                              )
                            );
                          })}
                        </SubMenu>
                      )
                    );
                  }
                } else {
                  return (
                    isAllowedService(`${service.name}`) && (
                      <Menu.Item
                        key={service?.path}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                        className={pathname === service?.path ? "active" : ""}
                      >
                        <Link to={service?.path as any}>{service?.name}</Link>
                      </Menu.Item>
                    )
                  );
                }
              })}
            </>
          ) : (
            <>
              <SubMenu
                key={"sub1"}
                icon={<AppstoreOutlined />}
                title={"Basic Information 666"}
              >
                <Menu.Item
                  key="/details"
                  className={`hover:text-white hover:bg-gray-100 ${
                    pathname.includes("/details") ? "active bg-gray-100" : ""
                  }`}
                  icon={<IdcardOutlined />}
                >
                  <Link
                    to={`/shops/${shopInfo?.id}/details`}
                    className="hover:text-white"
                  >
                    Basic Information 6666
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/banks"
                  icon={<SolutionOutlined />}
                  className={
                    pathname.includes("/banks") ? "active bg-gray-100" : ""
                  }
                >
                  <Link to={`/shops/${shopInfo?.id}/banks`}>Bank Info</Link>
                </Menu.Item>
                <Menu.Item
                  key="/users"
                  icon={<SolutionOutlined />}
                  className={
                    pathname.includes("/users") ? "active bg-gray-100" : ""
                  }
                >
                  <Link to={`/shops/${shopInfo?.id}/users`}>Users</Link>
                </Menu.Item>
                <Menu.Item
                  key="/contact-address"
                  icon={<SolutionOutlined />}
                  className={
                    pathname.includes("/contact-address")
                      ? "active bg-gray-100"
                      : ""
                  }
                >
                  <Link to={`/shops/${shopInfo?.id}/contact-address`}>
                    Business Info
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/facebook-page"
                  icon={<SolutionOutlined />}
                  className={
                    pathname.includes("/facebook-page")
                      ? "active bg-gray-100"
                      : ""
                  }
                >
                  <Link to={`/shops/${shopInfo?.id}/facebook-page`}>
                    Facebook Page & Group
                  </Link>
                </Menu.Item>
              </SubMenu>

              {type !== "JC_BOOKING" && type === "JC_AFFILIATE" ? (
                <>
                  <Menu.Item
                    key="/affiliate-products"
                    icon={<SolutionOutlined />}
                    className={
                      pathname.includes("/affiliate-products") ? "active" : ""
                    }
                  >
                    <Link to={`/shops/${shopInfo?.id}/affiliate-products`}>
                      Product List
                    </Link>
                  </Menu.Item>
                </>
              ) : (
                <>
                  <SubMenu
                    key={"sub2"}
                    icon={<AppstoreOutlined />}
                    title={"Product Management"}
                  >
                    <Menu.Item
                      key="/products"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/products")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/products`}>
                        Product
                      </Link>
                    </Menu.Item>
                    {merchantInfo?.type !== "RESELLER" && (
                      <>
                        <Menu.Item
                          key="/requested-products"
                          icon={<SolutionOutlined />}
                          className={
                            pathname.includes("/requested-products")
                              ? "active bg-gray-100"
                              : ""
                          }
                        >
                          <Link
                            to={`/shops/${shopInfo?.id}/requested-products`}
                          >
                            Requested Products
                          </Link>
                        </Menu.Item>
                      </>
                    )}
                    <Menu.Item
                      key="/product-catalogue"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/product-catalogue")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/product-catalogue`}>
                        Product Catalogue
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/out-of-stock"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/out-of-stock")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/out-of-stock`}>
                        Out of Stock
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/categories"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/categories")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/categories`}>
                        Category Management
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key="/brands"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/brands") ? "active bg-gray-100" : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/brands`}>
                        Brand List
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                  <SubMenu
                    key={"sub3"}
                    icon={<AppstoreOutlined />}
                    title={"Promotion"}
                  >
                    <Menu.Item
                      key="/promo-code"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/promo-code")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/promo-code`}>
                        Promo Code
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/campaign"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/campaign")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/campaign`}>
                        Campaign
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                  <SubMenu
                key={"sub4"}
                icon={<AppstoreOutlined />}
                title={"Orders & Review"}
              >
                  <Menu.Item
                    key="/orders"
                    icon={<ShoppingCartOutlined />}
                    className={`hover:text-white hover:bg-gray-100 ${
                      pathname.includes("/orders") ? "active bg-gray-100" : ""
                    }`}
                  >
                    <Link to={`/shops/${shopInfo?.id}/orders`}>
                      Orders List
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="/return-order"
                    icon={<ShoppingCartOutlined />}
                    className={`hover:text-white hover:bg-gray-100 ${
                      pathname.includes("/return-order") ? "active bg-gray-100" : ""
                    }`}
                  >
                    <Link to={`/shops/${shopInfo?.id}/return-order`}>
                      Return Orders
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="/group-order-list"
                    icon={<ShoppingCartOutlined />}
                    className={`hover:text-white hover:bg-gray-100 ${
                      pathname.includes("/group-order-list") ? "active bg-gray-100" : ""
                    }`}
                  >
                    <Link to={`/shops/${shopInfo?.id}/group-order-list`}>
                      Group Buy List
                    </Link>
                  </Menu.Item>
                  </SubMenu>
                  <SubMenu
                    key={"sub6"}
                    icon={<AppstoreOutlined />}
                    title={"Reports"}
                  >
                    <Menu.Item
                      key="/sales-report"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/sales-report")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/sales-report`}>
                      Sales Report
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/sales-summary"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/sales-summary")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/sales-summary`}>
                      Sales Summary
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/top-sales-product"
                      icon={<SolutionOutlined />}
                      className={
                        pathname.includes("/top-sales-product")
                          ? "active bg-gray-100"
                          : ""
                      }
                    >
                      <Link to={`/shops/${shopInfo?.id}/top-sales-product`}>
                      Top Sales Product
                      </Link>
                    </Menu.Item>
                  
                  </SubMenu>
                  <Menu.Item
                    key="/chats"
                    icon={<SolutionOutlined />}
                    className={
                      pathname.includes("/chats") ? "active bg-gray-100" : ""
                    }
                  >
                    <Link to={`/shops/${shopInfo?.id}/chats`}>Chats</Link>
                  </Menu.Item>
                </>
              )}

              <Menu.Item
                key="/transactions"
                icon={<SyncOutlined />}
                className={pathname.includes("/transactions") ? "active" : ""}
              >
                <Popconfirm
                  placement="left"
                  title="Do you want to login this Merchant?"
                  visible={shopInfo?.id === visiblePopconfirm}
                  onConfirm={(e: any) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onSetDefault(shopInfo?.id);
                  }}
                  okButtonProps={{
                    loading: confirmLoading,
                    className: "bg-blue-400",
                    shape: "round",
                  }}
                  cancelButtonProps={{
                    danger: true,
                    type: "primary",
                    shape: "round",
                  }}
                  okText="Yes"
                  cancelText="Not now"
                  onCancel={handleCancel}
                >
                  <Link
                    to={""}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      showPopconfirm(shopInfo?.id);
                    }}
                  >
                    Switch to Merchant
                  </Link>
                </Popconfirm>
              </Menu.Item>
            </>
          )}
        </Menu>
      </Sider>
    </>
  );
};

export default MainSidebar;
